(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function format(totalSeconds) {
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor(totalSeconds / 3600) % 24;
    var minutes = Math.floor(totalSeconds / 60) % 60;
    var seconds = totalSeconds % 60;
    if (days > 0) {
      return days + 'd ' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    }
    return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  function tick(el, digits) {
    var intervalSeconds = parseInt(el.dataset.intervalSeconds, 10);
    if (!intervalSeconds) return;
    var nowSeconds = Math.floor(Date.now() / 1000);
    var remaining = intervalSeconds - (nowSeconds % intervalSeconds);
    var str = format(remaining);
    if (digits.textContent !== str) {
      digits.textContent = str;
    }
  }

  function init(el) {
    if (el.dataset.saleCountdownInit) return;
    el.dataset.saleCountdownInit = 'true';
    var digits = el.querySelector('[data-inventory-countdown-digits]');
    if (!digits) return;
    tick(el, digits);
    setInterval(function () {
      tick(el, digits);
    }, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-inventory-countdown]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
